import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../lib/motion";
import { CHAPTERS } from "../data/site";

export const CollabCards = () => {
  return (
    <section id="wspolpraca" className="relative py-[clamp(64px,9vw,120px)]" data-testid="collab-section">
      <div className="container-pm">
        <Reveal className="max-w-[42ch] mb-14">
          <p className="eyebrow mb-4">Modele współpracy</p>
          <h2 className="font-display font-semibold text-white text-[clamp(34px,4.4vw,58px)] leading-[1.02] tracking-[-0.035em]">
            Dwie drogi. <span className="text-coral">Jeden cel</span> — Twój sukces.
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6">
          {CHAPTERS.map((c, i) => {
            const isCoral = c.accent === "coral";
            return (
              <Reveal key={c.n} delay={i * 0.12} className="group">
                <div className="pm-card relative overflow-hidden h-[420px] flex">
                  <img
                    src={c.img}
                    alt={c.title}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                    style={{ objectPosition: "right center" }}
                    width="640"
                    height="480"
                  />
                  <div className="absolute inset-0 photo-overlay" />
                  <div className="relative z-10 p-8 md:p-9 flex flex-col justify-end max-w-[68%]">
                    <span
                      className="font-display text-6xl font-bold leading-none mb-4 opacity-30"
                      style={{ color: isCoral ? "var(--coral)" : "var(--violet)" }}
                    >
                      {c.n}
                    </span>
                    <h3
                      className="font-display font-semibold text-[clamp(24px,2.4vw,32px)] leading-tight mb-3"
                      style={{ color: isCoral ? "var(--coral)" : "var(--violet)" }}
                    >
                      {c.title}
                    </h3>
                    <p className="text-sm text-white/80 mb-6 max-w-[38ch]">{c.text}</p>
                    <a
                      href="#aplikuj"
                      data-testid={`collab-cta-${c.n}`}
                      className="inline-flex w-fit items-center gap-2 h-11 px-5 rounded-lg text-sm font-bold text-white transition-transform hover:-translate-y-0.5"
                      style={{ background: isCoral ? "var(--coral)" : "var(--violet)" }}
                    >
                      Zobacz szczegóły <ArrowRight size={16} />
                    </a>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
